import
{
     SiJavascript as JS,
     SiCss3 as CSS,
     SiReact as React,
     SiTypescript as TypesScript,
     SiPython as Python,
     SiHtml5 as HTML,
     SiNextdotjs as Next,
     SiPhp as Php,
     SiRuby as Ruby,
     SiCsharp as CSharp,
     SiAndroid as Android,
     SiAngular as Angular,
     SiAssemblyscript as Assembly,
     SiBlender as Blender,
     SiC as C,
     SiDelphi as Delphi,
     SiEvernote as Evernote,
     SiFigma as Figma,
     SiGithub as Github,
     SiGitlab as GitLab,
     SiGo as GO,
     SiGoogledrive as GoogleDrive,
     SiHeroku as Heroku,
     SiIos as IOS,
     SiJava as Java,
     SiLaragon as Laragon,
     SiLinux as Linux,
     SiLua as Lua,
     SiMarkdown as Markdown,
     SiMysql as MySql,
     SiNpm as Npm,
     SiPowerbi as Powerbi,
     SiRedux as Redux,
     SiSlack as Slack,
     SiTailwindcss as Tailwind,
     SiUnity as Unity,
     SiVisualstudiocode as VsCode,
     SiWebpack as WebPack,
     SiYarn as Yarn,
     SiNodedotjs as Node
} from "react-icons/si";



const DataBaseIcons =[
     
          { value: "JSvanilla", icon: <JS /> },
          { value: "Css", icon: <CSS /> },
          { value: "React", icon: <React /> },
          { value: "Typescript", icon: <TypesScript /> },
          { value: "Python", icon: <Python /> },
          { value: "HTML", icon: <HTML /> },
          { value: "Next", icon: <Next /> },
          { value: "Php", icon: <Php /> },
          { value: "Ruby", icon: <Ruby /> },
          { value: "C#", icon: <CSharp /> },
          { value: "Android", icon: <Android /> },
          { value: "Angular", icon: <Angular /> },
          { value: "Assembly", icon: <Assembly /> },
          { value: "Blender", icon: <Blender /> },
          { value: "C", icon: <C /> },
          { value: "Delphi", icon: <Delphi /> },
          { value: "Evernote", icon: <Evernote /> },
          { value: "Figma", icon: <Figma /> },
          { value: "GitHub", icon: <Github /> },
          { value: "GitLab", icon: <GitLab /> },
          { value: "GO", icon: <GO /> },
          { value: "GoogleDrive", icon: <GoogleDrive /> },
          { value: "Heroku", icon: <Heroku /> },
          { value: "IOS", icon: <IOS /> },
          { value: "Java", icon: <Java /> },
          { value: "Laragon", icon: <Laragon /> },
          { value: "Linux", icon: <Linux /> },
          { value: "Lua", icon: <Lua /> },
          { value: "Markdown", icon: <Markdown /> },
          { value: "MySql", icon: <MySql /> },
          { value: "Npm", icon: <Npm /> },
          { value: "Powerbi", icon: <Powerbi /> },
          { value: "Redux", icon: <Redux /> },
          { value: "Slack", icon: <Slack /> },
          { value: "Tailwind", icon: <Tailwind /> },
          { value: "Unity", icon: <Unity /> },
          { value: "VsCode", icon: <VsCode /> },
          { value: "WebPack", icon: <WebPack /> },
          { value: "Yarn", icon: <Yarn /> },
          { value: "Node", icon: <Node /> },
     ];

const DataBaseTechs = [
     { value: "JSvanilla", label: "JSVanilla" },
     { value: "Css", label: "Css" },
     { value: "React", label: "React" },
     { value: "Typescript", label: "Typescript" },
     { value: "Python", label: "Python" },
     { value: "HTML", label: "HTML" },
     { value: "Next", label: "Next" },
     { value: "Node", label: "Node" },
     { value: "Php", label: "Php" },
     { value: "Ruby" ,label:"Ruby"},
     { value: "C#", label:"C#"},
     { value: "Android", label:"Android"},
     { value: "Angular", label:"Angular"},
     { value: "Assembly", label:"Assembly"},
     { value: "Blender",  label:"Blender"},
     { value: "C", label:"C"},
     { value: "Delphi", label:"Delphi"},
     { value: "Evernote", label:"Evernote"},
     { value: "Figma",label:"Figma"},
     { value: "GitHub", label:"GitHub"},
     { value: "GitLab", label:"GitLab"},
     { value: "GO", label:"GO" },
     { value: "GoogleDrive",  label:"GoogleDrive"},
     { value: "Heroku",label:"Heroku"},
     { value: "IOS", label:"IOS"},
     { value: "Java",label:"Java"},
     { value: "Laragon",label:"Laragon"},
     { value: "Linux",label:"Linux"},
     { value: "Lua",label:"Lua"},
     { value: "Markdown",label:"Markdown"},
     { value: "MySql", label:"MySql"},
     { value: "Npm", label:"Npm"},
     { value: "Powerbi", label:"Powerbi" },
     { value: "Redux", label:"Redux"   },
     { value: "Slack",  label:"Slack"   },
     { value: "Tailwind", label:"Tailwind"},
     { value: "Unity", label:"Unity"   },
     { value: "VsCode", label:"VsCode"  },
     { value: "WebPack", label:"WebPack" },
     { value: "Yarn", label:"Yarn"},
   
];



export { DataBaseIcons,DataBaseTechs }
